import React from 'react';
import Box from '@mui/material/Box';
/**
 *
 * @param {BlinkProps} props - Blink component wrapper props object.
 * @param {string} props.id - Blink element id.
 * @param {ReactNode} props.children - Children components of Blink.
 * @param {number} props.ratio - Number of times the element should blink per unit time.
 * @param {number} props.unit - Number of seconds as unit of measurement.
 *
 * @returns {React.JSX.Element}
 */

export default function Blink({ id, children, ratio = 0, unit = 1 }) {
  const intervalPercentage = 100 / ratio; // Percentage of time per blink cycle

  const keyframes = Array.from({ length: ratio }).reduce((acc, _, index) => {
    const percentage = index * intervalPercentage;
    const opacity = index % 2 === 0 ? 1 : 0;
    acc[`${percentage}%`] = { opacity };
    return acc;
  }, {});

  return (
    <Box
      sx={{
        [`@keyframes blink-${id}`]: keyframes,
        animation: `blink-${id} ${unit}s infinite`,
        display: 'inline-flex',
      }}
    >
      {children}
    </Box>
  );
}
